'use strict';

angular.module('youth').controller('TrackerCtrl', ['daily', 'historySvc', function (daily, historySvc) {
  var vm = this;
  vm.tab = 'day';
  // fetch the weekly first. priming this in case they change tabs since this call is slow
  historySvc.getWeekly().then(function (dat) {
    vm.weekly = dat;
    // then monthly: even slower!
    historySvc.getMonthly().then(function (dat) {
      vm.monthly = dat;
    });
  });
  vm.daily = daily;
  vm.validActivityType = function (entry) {
    return entry.activityType.normal;
  };
  // get the colour a summary value should be
  vm.getColor = function (value) {
    if (vm.tab === 'week') {
      return value < 2 ? 'purple' : value > 3 ? 'green' : '';
    } else {
      return value < 5 ? 'purple' : value > 10 ? 'green' : '';
    }
  };
}]).filter('deca', function () {
  return function (input) {
    return Math.ceil(input / 10) * 10;
  };
});